<template>
	<div class="main">
		<h1>Lista de pagos</h1>
		<br />

		<v-card class="rounded-lg payment-card">
			<div class="before-table">
				<h1>Pagos</h1>
				<br />

				<div class="before-table-row">
					<v-select
						:items="paymentStatusItems"
						label="Estado del pago"
						v-model="options.selectedStatus"
					></v-select>
					<div class="mx-2"></div>

					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Buscar por #Pedido"
						@change="fetchPayments"
					></v-text-field>
				</div>
			</div>

			<v-data-table
				:headers="headers"
				:items="payments"
				class="payment-list-table"
				:server-items-length="paymentCount"
				:page="1"
				:options.sync="options"
				:loading="loading"
				@update:options="optionsUpdate"
				:footer-props="{
					itemsPerPageOptions: [5, 10, 20],
					itemsPerPageText: 'Pagos por página',
					pageText: `${
						1 + options.itemsPerPage * (options.page - 1)
					}-${
						options.itemsPerPage * (options.page - 1) +
						payments.length
					} de ${paymentCount}`,
					showFirstLastPage: true,
				}"
				:header-props="{
					sortByText: 'Ordenar por',
				}"
			>
				<template #no-data>No hay pagos</template>
				<template #item.transactionId="{item}">
					<span style="font-family: 'monospace';">{{
						item.transactionId
					}}</span>
				</template>
				<template #item.createdAt="{item}">
					{{ item.createdAt | formatDate }}
				</template>

				<template #item.status="{item}">
					<v-chip dark color="success" v-if="item.completed"
						><b>Completado</b></v-chip
					>

					<v-chip dark color="info" v-if="item.pending"
						><b>Pendiente</b></v-chip
					>

					<v-chip dark color="error" v-if="item.rejected"
						><b>Rechazado</b></v-chip
					>
				</template>

				<template #item.actions="{item}">
					<v-btn
						class="mx-1 rounded-lg"
						elevation="0"
						color="warning"
						v-if="!item.completed"
						@click="completePayment(item.transactionId, true)"
						>Aceptar pago</v-btn
					>
					<v-btn
						class="mx-1 rounded-lg"
						elevation="0"
						color="error"
						v-if="!item.completed && !item.rejected"
						@click="completePayment(item.transactionId, false)"
						>Rechazar pago</v-btn
					>

					<v-btn
						class="mx-1 rounded-lg"
						elevation="0"
						color="success"
						v-if="item.completed"
						@click="completePayment(item.transactionId, true)"
						>Reconfirmar</v-btn
					>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
	import moment from "moment";
	import axios from "axios";
	export default {
		name: "PaymentList",
		data: () => ({
			payments: [],
			options: {
				itemsPerPage: 10,
				page: 1,
				orderBy: "createdAt",
				orderDesc: false,
				selectedStatus: false,
			},
			search: "",
			paymentCount: 0,

			loading: false,
			paymentStatusItems: [
				{ value: false, text: "Todos" },
				{ value: "pending", text: "Pendiente" },
				{ value: "completed", text: "Completado" },
				{ value: "rejected", text: "Rechazado" },
			],

			headers: [
				{
					align: "center",
					text: "#Pedido",
					value: "transactionId",
				},
				{
					align: "center",
					text: "Usuario",
					value: "username",
				},
				{ align: "center", text: "Fecha", value: "createdAt" },
				{
					align: "center",
					text: "Estado",
					value: "status",
					sortable: false,
					filterable: false,
				},
				{
					align: "center",
					text: "Acciones",
					value: "actions",
					sortable: false,
					filterable: false,
				},
			],
		}),
		filters: {
			formatDate(value) {
				return moment(value).locale("es").format("LLL");
			},
		},
		watch: {
			options: {
				deep: true,
				handler() {
					this.fetchPayments();
				},
			},
		},
		mounted() {
			this.fetchPayments();
		},
		methods: {
			async fetchPayments() {
				try {
					this.$emit("loading", true);
					this.loading = true;
					const response = await axios.get("/admin/payment-list", {
						params: {
							page: this.options.page,
							limit: this.options.itemsPerPage,
							sortBy: this.options.sortBy,
							sortDesc: this.options.sortDesc,
							status: this.options.selectedStatus,
							search: this.search,
						},
					});

					this.payments = response.data.payments;
					this.paymentCount = response.data.paymentCount;
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$router.push({ name: "AdminLogin" });
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.$emit("loading", false);
					this.loading = false;
				}
			},

			async completePayment(transactionId, accepted) {
				try {
					await axios.post("/admin/payment/", {
						transactionId,
						accepted,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha realizado con éxito la acción",
					});
				} catch (error) {
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido completar la petición",
					});
				} finally {
					this.fetchPayments();
				}
			},

			optionsUpdate(e) {
				this.options = e;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.main {
		padding: 2em;
	}

	.payment-card {
		.before-table {
			padding: 2em;

			.before-table-row {
				display: flex;
				flex-wrap: wrap;
			}
		}
	}
	.payment-list {
		.v-expansion-panel-header {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;

			.avatar {
				height: 48px;
				width: 48px;
				flex: initial;
				border-radius: 50%;
			}

			p {
				margin: 0 0 0 1em;
			}
		}

		.v-expansion-panel-content {
			padding: 2em 0;
			background-color: #f0f0f0;
		}
	}
</style>

<style lang="scss">
	.payment-list-table {
		&.v-data-table table tbody td {
			padding: 1em !important;
		}
	}
</style>
